import React from "react";
import { BiSolidLock } from "react-icons/bi";
import { Button } from "reactstrap";
import AuthWrapper from "../../components/AuthWrapper";
import FormInput from "../../components/formInput/FormInput";

const UpdatePassword = () => {
  return (
    <AuthWrapper
        title="Update Password"
        description="Create a strong new password to secure your account access."
    >
      <div className="d-flex flex-column gap-3">
          <div>
            <label className="form-label small fw-600 text-muted mb-1">New Password</label>
            <FormInput
                type="password"
                placeholder="••••••••"
                className="w-100 rounded-3 border-light py-2"
                size="large"
            />
          </div>

          <div>
            <label className="form-label small fw-600 text-muted mb-1">Confirm New Password</label>
            <FormInput
                type="password"
                placeholder="••••••••"
                className="w-100 rounded-3 border-light py-2"
                size="large"
            />
          </div>

          <div className="mt-2">
            <Button
              type="submit"
              className="w-100 rounded-3 border-0 py-2 shadow-sm text-white fw-600"
              style={{
                 background: "linear-gradient(90deg, #00509d, #182848)",
                 height: "48px"
              }}
            >
              Update & Login
            </Button>
          </div>
      </div>
    </AuthWrapper>
  );
};

export default UpdatePassword;

